<div class="Truck IsSkeleton">
    <div class="Skeleton skeleton-large-rect"></div>
    <div class="SkeletonLight skeleton-thinline-rect"></div>
    <div class="SkeletonLight skeleton-medium-rect"></div>
    <div class="divImageContainer">
        <div class="SkeletonLight skeleton-square"></div>
        <div class="SkeletonLight skeleton-small-rect"></div>
    </div>
</div>
